<script setup>
import CFIcon from '@/ui/Icon/CFIcon.vue';

defineOptions({
    inheritAttrs: false,
});

defineProps({
    text: {
        type: String,
        required: true,
    },
    /** @type import('vue').PropType<IconName> */
    icon: {
        type: String,
        default: undefined,
    },
});
</script>

<template>
    <button
        type="button"
        class="flex cursor-pointer items-center gap-1.5 px-3 py-2"
        v-bind="$attrs"
    >
        <span class="border-primary border-b">
            {{ text }}
        </span>
        <CFIcon
            v-if="icon"
            :name="icon"
            size="16"
        />
    </button>
</template>
